import { Axios } from '../utils/http';
let baseURL = 'https://saas.sscanmou.com/apiV2/pc';
if (process.env.NODE_ENV === 'development') {
    // 开发
    baseURL = '/saasBase';
}
// 获取宏观数据下拉列表
export function eventRegistrationSEM(data) {
    return Axios.post(baseURL + `/v1/saas/mch/eventRegistration`, data).then(res => res.data);
}
// 发送短信验证码接口
export function registerSendSms(data) {
    return Axios.post(baseURL + `/v1/saas/registerSendSms`, data).then(res => res.data);
}
// 游客模式获取省市区数据
export function listOpenCityData() {
    return Axios.get(baseURL + `/v1/saas/data/listOpenCityData`).then(res => res.data);
}